import type { ReactNode } from 'react'
import React from 'react'

import { FixedRatesTableColumn } from '../FixedRatesTableColumn/FixedRatesTableColumn'
import * as S from './FixedRatesTable.styled'

type FixedRatesTableProps = {
  children: ReactNode
}

export const FixedRatesTable = ({ children }: FixedRatesTableProps) => {
  return <S.Container>{children}</S.Container>
}

FixedRatesTable.Column = FixedRatesTableColumn
